module.exports = __webpack_public_path__ + "img/work-sans-v4-latin-ext-700.d5f0a562.svg";